<template>
  <div class="dashboard">
    <div style="width:1140px">
      <div id="upload" class="dashboard-container">
        <!-- :auto-upload='false' -->
        <div v-if="fileCheckData!==null" class="dashboard-toplayout">
          <span class="dashboard-toplayout-ftsbig">上传资源</span>
          <div v-if="fileCheckData!=null" class="dashboard-toplayout-right">
            <p class="dashboard-toplayout-mgright">支持上传类型</p>
            <div class="dashboard-toplayout-btn dashboard-toplayout-space">

              <span>图片</span><span>视频</span><span>音频</span><span>PDF</span><span>压缩包</span>
            </div>
            <!-- <div class="dashboard-toplayout-num">
              {{ fileCheckData.supportFileTypes }}
            </div> -->
            <p class="dashboard-toplayout-mgright">上传文件数量</p>
            <div class="dashboard-toplayout-num">{{ fileCheckData.perFileCountLimit }}</div>
            <p class="dashboard-toplayout-mgright">单个文件大小</p>
            <div class="dashboard-toplayout-num">{{ fileCheckData.perFileSizeLimit/1024 }}G</div>

          </div>
        </div>
        <el-upload
          v-if="fileCheckData!==null"
          ref="uploadtable"
          class="avatar-uploader"
          action=""
          :on-exceed="onExceed"
          :limit="fileCheckData.perFileCountLimit"
          :auto-upload="false"
          :on-change="onChange"
          multiple
          drag
          :show-file-list="false"
        >
          <span class="avatar-uploader-text">将文件拖拽到此处</span>
          <el-button type="primary" class="avatar-uploader-btn" size="small">选择文件</el-button>
          <span class="avatar-uploader-stext">按住Ctrl或Shift可多选</span>
        <!-- <img v-if="imageUrl" :src="imageUrl" class="avatar">
    <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
        </el-upload>

      </div>
      <div id="list" class="dashboard-container">

        <div class="dashboard-toplayout">
          <!-- <el-divider class="dashboard-divider" direction="vertical"> </el-divider> -->
          <span class="dashboard-toplayout-ftsbig">上传列表</span>

        </div>
        <el-table v-show="indexSize==0" :data="fileList" row-key="uid" :row-style="rowStyle" style="width: 100%;margin: 20px 0px;" empty-text="请上传资源" :header-cell-style="{fontSize: '12px',color:'#7B84A1',padding:'0px',textAlign:'center',opacity: '0.5'}">

          <el-table-column label="文件" prop="name" width="360" align="center" />
          <el-table-column label="类型" prop="type" width="80px" align="center" />
          <el-table-column label="大小" width="80px" :formatter="getfilesize" prop="size" align="center" />
          <el-table-column label="上传进度" width="340" prop="progress" align="center" />
          <el-table-column label="状态" prop="status" width="80px" align="center" />
          <el-table-column label="操作" width="160px" align="center" />
        </el-table>
        <el-table v-show="indexSize!=0" :data="fileList" row-key="uid" :row-style="rowStyle" style="width: 100%;margin: 20px 0px;" empty-text="请上传资源" :header-cell-style="{fontSize: '12px',color:'#7B84A1',padding:'0px',textAlign:'center',opacity: '0.5'}">

          <el-table-column label="文件" prop="name" width="360" align="center">
            <template slot-scope="scope">
              <div class="row">
                <img v-if="scope.row.type.indexOf('image')!=-1" src="@/assets/img.png" alt="404">
                <img v-if="scope.row.type.indexOf('pdf')!=-1" src="@/assets/pdf.png" alt="404">
                <img v-if="scope.row.type.indexOf('video')!=-1" src="@/assets/video.png" alt="404">
                <img v-if="scope.row.type.indexOf('audio')!=-1" src="@/assets/rec.png" alt="404">
                <img v-if="scope.row.type.indexOf('zip')!=-1" src="@/assets/zip.png" alt="404">
                <span style="margin-left:8px">{{ scope.row.name }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="类型" prop="type" width="80px" align="center">

            <template slot-scope="scope">
              <span v-if="scope.row.type.indexOf('image')!=-1">图片</span>
              <span v-if="scope.row.type.indexOf('pdf')!=-1">PDF</span>
              <span v-if="scope.row.type.indexOf('video')!=-1">视频</span>
              <span v-if="scope.row.type.indexOf('audio')!=-1">音频</span>
              <span v-if="scope.row.type.indexOf('zip')!=-1">压缩包</span>

            </template>
          </el-table-column>
          <el-table-column label="大小" width="80px" :formatter="getfilesize" prop="size" align="center" />
          <el-table-column label="上传进度" width="340" prop="progress" align="center">

            <template slot-scope="scope">

              <el-progress :percentage="scope.row.progress" :show-text="false" :status="customColorMethod(scope.row)" />

            </template>

          </el-table-column>
          <el-table-column label="状态" prop="status" width="80px" align="center">
            <template slot-scope="scope">
              <div class="row" style="justify-content:center">

                <img v-if="scope.row.status=='失败'" src="@/assets/interrupt.png" alt="404">
                <img v-else-if="scope.row.status=='完成'" src="@/assets/success.png" alt="404">
                <i v-else class="el-icon-loading" />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="说明" width="80px" align="center">
            <template slot-scope="scope">

              <span>{{ scope.row.uploadDescript }}</span>

            </template>
          </el-table-column>
          <el-table-column label="操作" width="80px" align="center">
            <template slot-scope="scope">
              <div class="row" style="justify-content:center">

                <img v-if="scope.row.status=='失败'" class="row-img" src="@/assets/again.png" alt="404" @click="refreshUpload(scope.row)">
                <img class="row-img" src="@/assets/dele.png" alt="404" @click="abortMultipartUpload(scope)">

              </div>
            </template>
          </el-table-column>
        </el-table>

      </div>
      <div class="dashboard-container">

        <div class="dashboard-toplayout">
          <!-- <el-divider class="dashboard-divider" direction="vertical"> </el-divider> -->
          <span class="dashboard-toplayout-ftsbig">温馨提示</span>

        </div>

        <ol class="dashboard-toplayout-ftsnomal">
          <li>
            发布馆藏需拥有上传内容的“原创著作权”，知晓并同意 <a class="dashboard-toplayout-margin" style="text-decoration:underline" target="_blank" href="https://adks.cnmrms.com/#/privacy?t=potocal">《服务使用协议》</a>
            、<a class="dashboard-toplayout-margin" style="text-decoration:underline" href="https://adks.cnmrms.com/#/privacy?t=secret" target="_blank">《个人信息保护政策》</a> 相关内容。
          </li>
          <li>上传过程中请不要关闭页面或删除原始照片和视频。</li>
        </ol>

      </div>
      <div id="next" class="dashboard-container" style="padding:0px;margin-bottom:20px">
        <el-button v-loading="nextButton" type="primary" style="width:100%;background-color:#4C70E8;font-size: 14px;font-weight:bold;border-radius: 5px;" size="default" @click="uploadnext">下一步·资源审核</el-button>
      </div>
    </div>
    <div>
      <div class="rowright">
        <div class="rowright-contain" @click="scrollViewId('#upload')">

          <span class="rowright-btn">上传资源</span>

        </div>

        <div class="rowright-contain" style="margin-top:5px" @click="scrollViewId('#list')">

          <span class="rowright-btn">上传列表</span>
        </div>
        <div class="rowright-contain" style="margin-top:5px;height:54px;background-color:#4C70E8;" @click="scrollViewId('#next')">
          <!-- <a class="rowright-btn" @click="scrollViewId('#next')" style="background-color:#4C70E8;margin-top:5px;height: 54px;padding: 10px;"> -->

          <p class="rowright-next"> 下一步</p>

          <span class="rowright-btn" style="margin-top:4px">资源审核</span>
        </div>
      </div>
    </div>
    <tipall ref="tipall" />
  </div>
</template>

<script>
import SparkMD5 from 'spark-md5'

import {
  getUploadInfo,
  client,
  resourceCheckMd5,
  getByTenantId,
  collectionUpload
} from '@/api/upload'
import {
  dateFormat
} from '@/utils/validate'
import tipall from './tipall.vue'

export default {
  components: {
    tipall
  },
  props: {
    nextStatus: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      nextButton: false,
      tenantId: this.$store.getters.tenantId,
      fileList: [],
      indexSize: 0,
      fileCheckData: null,
      httpupload: null,
      checkpoints: {}
    }
  },

  watch: {
    fileList() {
      this.indexSize = this.fileList.length

      return this.fileList.length
    }
  },

  mounted() {
    this.getByTenantId()
  },
  methods: {
    async getByTenantId() {
      const res = await getByTenantId({
        tenantId: this.tenantId
      })
      if (res.data) {
        this.fileCheckData = res.data
      }
    },
    rowStyle({
      row,
      index
    }) {
      const styleJson = {
        'backgroundColor': '#fff',
        'border-bottom': '1px solid #EBEEF5',
        'border-top': '1px solid #EBEEF5'
      }
      return styleJson
    },
    onExceed() {
      this.$refs.tipall.isOpen('关闭', `文件超出${this.fileCheckData.perFileCountLimit}限制`)
    },
    checkFile(file) {
      const _self = this

      const fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase()
      const whiteList = this.fileCheckData.supportFileTypes.split(',')

      if (whiteList.indexOf(fileSuffix) === -1) {
        this.$refs.uploadtable.handleRemove(file, file.raw)
        this.$refs.tipall.isOpen('关闭', `暂时不支持此格式上传`)
        const index = _self.fileList.findIndex(list => list.uid === file.uid)
        if (index !== -1) {
          _self.fileList.splice(index, 1)
        }
        return false
      }

      const isLt2M = file.size / 1024 / 1024 < this.fileCheckData.perFileSizeLimit

      if (!isLt2M) {
        this.$refs.uploadtable.handleRemove(file, file.raw)
        this.$refs.tipall.isOpen('关闭', `上传文件大小不能超过${this.fileCheckData.perFileSizeLimit / 1024}GB限制`)
        const index = _self.fileList.findIndex(list => list.uid === file.uid)
        if (index !== -1) {
          _self.fileList.splice(index, 1)
        }
        return false
      }
      return true
    },
    onChange(file, fileList) {
      if (file.status === 'ready') {
        // const _this = this

        if (!this.checkFile(file.raw)) {
          return
        }
        const fileprogress = this.fileList.find(list => list.uid === file.uid)

        if (!fileprogress) {
          const item = {
            name: file.name,
            uid: file.uid,
            type: file.raw.type,
            size: file.size,
            md5: '',
            file: file,
            createtime: file.raw.lastModified,
            dir: '',
            progress: 0,
            status: '准备'
            // uploadBeginTime: dateFormat(new Date().getTime()),
            // webkitRelativePath: file.raw.webkitRelativePath
          }
          this.fileList.push(item)

          const uploadList = this.fileList.filter(element => {
            console.log(element.status)
            return element.status === '正在上传'
          }) // 生成数组

          if (uploadList.length < 5) {
            item.status = '正在上传'

            this.createMd5Url(item)
          }
        }
      } else {
        console.log('noready')
      }
    },
    // 计算MD5
    createMd5Url(file) {
      const _this = this
      const blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
      const chunkSize = 2097152
      const chunks = Math.ceil(file.size / chunkSize)
      let currentChunk = 0
      const spark = new SparkMD5.ArrayBuffer()
      const fileReader = new FileReader()
      // console.log('计算MD5...')
      file.cmd5 = true

      fileReader.onload = (e) => {
        spark.append(e.target.result) // Append array buffer
        currentChunk = (currentChunk + 10) < chunks ? (currentChunk + 10) : currentChunk + 1

        if (currentChunk < chunks) {
          // console.log(`第${currentChunk}分片解析完成, 开始第${currentChunk +1} / ${chunks}分片解析`);
          // let percent = Math.floor(currentChunk / chunks * 100);
          // console.log(percent);
          // file.cmd5progress = percent;
          loadNext()
        } else {
          const md5 = spark.end()

          spark.destroy() // 释放缓存
          file.md5 = md5
          _this.checkMd5(file)
        }
      }
      fileReader.onerror = () => {
        console.log('失败')
      }

      const loadNext = () => {
        const start = currentChunk * chunkSize
        const end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize

        fileReader.readAsArrayBuffer(blobSlice.call(file.file.raw, start, end))
      }

      loadNext()
    },
    async checkMd5(item) {
      const res = await resourceCheckMd5({
        'md5Codes': item.md5 + item.file.name.substring(item.file.name.lastIndexOf('.'), item.file.name.length),
        'tenantId': this.$store.getters.tenantId
      })
      console.log(res)
      if (!res.data) {
        this.checkMd5(item)
        return
      }
      if (res.data) {
        if (res.data.length > 0) {
          if (!res.data[0].exist) {
            item.dir = res.data[0].dir
            item.uploadBeginTime = dateFormat(new Date().getTime())
            item.status = '正在上传'
            this.fileupload(item.file.raw)
          } else {
            const existResource = res.data[0].existResource

            item.dir = res.data[0].existResource.resourcePath
            item.progress = 100
            item.uploadDescript = 'MD5重复'
            item.uploadBeginTime = existResource.resourceUploadBegin !== '' ? existResource.resourceUploadBegin : dateFormat(new Date().getTime())
            item.status = '完成'
            item.uploadEndTime = existResource.resourceUploadEnd !== '' ? existResource.resourceUploadEnd : dateFormat(new Date().getTime())
            this.toUpload()
          }
        }
      }
    },

    async resourceCheckMd5(md5, file) {
      const res = await resourceCheckMd5({
        'md5Codes': md5 + file.name.substring(file.name.lastIndexOf('.'), file.name.length).toLowerCase(),
        'tenantId': this.$store.getters.tenantId
      })
      if (res.data) {
        if (res.data.length > 0) {
          if (!res.data[0].exist) {
            const fileprogress = this.fileList.find(list => list.uid === file.uid)

            if (!fileprogress) {
              const item = {
                name: file.name,
                uid: file.uid,
                type: file.raw.type,
                size: file.size,
                md5: md5,
                file: file,
                createtime: file.raw.lastModified,
                dir: res.data[0].dir,
                uploadBeginTime: dateFormat(new Date().getTime()),

                progress: 0,
                status: '准备'
              }
              this.fileList.push(item)
              if (this.fileList.length < 5) {
                item.status = '正在上传'

                this.fileupload(file.raw)
              }
            }
            // this.fileupload(file.raw)
            // this.$refs.uploadtable.submit();
          } else {
            const existResource = res.data[0].existResource
            this.fileList.push({
              name: file.name,
              uid: file.uid,
              type: file.raw.type,
              size: file.size,
              md5: md5,
              file: file,
              createtime: file.raw.lastModified,
              dir: res.data[0].existResource.resourcePath,
              progress: 100,
              uploadDescript: 'MD5重复',
              uploadBeginTime: existResource.resourceUploadBegin !== '' ? existResource.resourceUploadBegin : dateFormat(new Date().getTime()),

              uploadEndTime: existResource.resourceUploadEnd !== '' ? existResource.resourceUploadEnd : dateFormat(new Date().getTime()),

              status: '完成'
            })
          }
        }
      }
    },
    scrollViewId(name) {
      document.querySelector(name).scrollIntoView(true)
    },
    async uploadnext() {
      if (this.fileList.length === 0) {
        this.$message({
          message: '请选择文件',
          type: 'error'
        })
        return
      }
      const index = this.fileList.findIndex(element => {
        return element.status !== '完成'
      })
      if (index !== -1) {
        this.$message({
          message: '请等待上传完成',
          type: 'warning'
        })
        return
      }
      var resourcesList = []
      this.fileList.forEach(element => {
        const md5Name = element.md5 + element.name.substring(element.name.lastIndexOf('.'), element.name.length).toLowerCase()
        const name = element.name.substring(0, element.name.lastIndexOf('.'))
        resourcesList.push({
          'resourceCloudName': md5Name, // 资源在云端的名称
          'resourceCreateTime': dateFormat(element.createtime), // 资源的创建时间
          'resourceMd5': element.md5,
          'resourceName': name,
          'resourceFileName': element.name, // 资源源名称
          'resourcePath': element.dir.charAt(element.dir.length - 1) === '/' ? element.dir + md5Name : element.dir, // dir + 文件名，如："java/mrms/img/" + "abc.jpg"
          'resourceSize': element.size,
          'resourceTime': element.resourceTime ? element.resourceTime : 0, // 音视频资源的时长
          'resourceUpdateTime': dateFormat(element.createtime), //  资源的最后编辑时间
          'resourceUploadBegin': element.uploadBeginTime,
          'resourceUploadEnd': element.uploadEndTime
        })
      })
      this.nextButton = true
      const res = await collectionUpload({
        collectionVOs: [{
          'collectionName': '',
          status: this.nextStatus,
          resources: resourcesList
        }],
        tenantId: this.$store.getters.tenantId
      })
      this.nextButton = false
      if (res.data) {
        this.$router.push({
          path: '/single',
          query: {
            collectionId: res.data
          }
        })
        this.$emit('uploadNext')
      }
    },

    customColorMethod(row) {
      if (row.status === '完成') {
        return 'success'
      } else if (row.status === 'warning') {
        return 'exception'
      } else if (row.status === '失败') {
        return 'exception'
      } else {
        return
      }
    },
    getfilesize(row) { // 把字节转换成正常文件大小
      const size = row.size
      if (!size) return ''
      var num = 1024.00 // byte
      // return (size / Math.pow(num, 2)).toFixed(2) + ''; //M
      if (size < num) {
        return size + 'B'
      }
      if (size < Math.pow(num, 2)) {
        return (size / num).toFixed(2) + 'KB'
      } // kb
      if (size < Math.pow(num, 3)) {
        return (size / Math.pow(num, 2)).toFixed(2) + 'MB'
      } // M
      if (size < Math.pow(num, 4)) {
        return (size / Math.pow(num, 3)).toFixed(2) + 'G'
      } // G
      return (size / Math.pow(num, 4)).toFixed(2) + 'T' // T
    },

    async refreshUpload(row) {
      row.status = '准备'
      row.uploadDescript = '重新上传'
      // const postinMd5 = await localStorage.getItem(row.md5)
      if (row.upload) {
        const postinMd5 = this.checkpoints[row.uploadId]
        if (postinMd5) {
          this.resumeUpload(row, row.file.raw, postinMd5)
        } else {
          this.putUpload(row, row.file.raw)
        }
      } else {
        this.putUpload(row, row.file.raw)
      }
    },

    getMp3VideoTime(file) {
      var audio = new Audio()
      audio.src = URL.createObjectURL(file)
      // 元数据已加载
      audio.addEventListener('loadedmetadata', function(e) {
        file.resourceTime = audio.duration
      })
    },
    toUpload() {
      const index = this.fileList.findIndex(element => {
        return element.status === '准备'
      })

      if (index !== -1) {
        this.createMd5Url(this.fileList[index])
      }
    },
    async fileupload(file) {
      const that = this

      const fileprogress = that.fileList.find(list => {
        return list.uid === file.uid
      })

      if (fileprogress.type.indexOf('video') !== -1 || fileprogress.type.indexOf('audio') !== -1) {
        var audio = new Audio()
        audio.src = URL.createObjectURL(file)
        // 元数据已加载
        audio.addEventListener('loadedmetadata', function(e) {
          fileprogress.resourceTime = audio.duration
        })
      }

      this.putUpload(fileprogress, file)
    },

    async putUpload(fileprogress, file) {
      const that = this
      if (that.httpupload === null) {
        const res = await getUploadInfo()

        that.httpupload = client(res.data)
      }

      const fileSuffix = fileprogress.name.substring(fileprogress.name.lastIndexOf('.') + 1).toLowerCase()
      return await that.httpupload.multipartUpload(fileprogress.dir + fileprogress.md5 + '.' + fileSuffix, file, {
        parallel: 5,
        partSize: 1024 * 1024,

        progress: function(p, checkpoint) {
          if (checkpoint) {
            fileprogress.uploadId = checkpoint.uploadId
            that.checkpoints[checkpoint.uploadId] = checkpoint
          }

          // fileprogress.progress = parseInt(p * 100)
          const progress = parseInt(p * 100)
          if (fileprogress.progress < progress) {
            fileprogress.progress = parseInt(p * 100)
          }
        }
        // meta: { year: 2020, people: 'dev' },
        // mime: this.file.type
      }).then(result => {
        if (result.res.status === 200) {
          fileprogress.status = '完成'
          fileprogress.uploadDescript = ''
          fileprogress.uploadEndTime = dateFormat(new Date().getTime())
          delete that.checkpoints[fileprogress.uploadId]
          that.toUpload()
        }
      }).catch(err => {
        console.error(err)
        fileprogress.uploadDescript = '上传中断'
        fileprogress.progress = fileprogress.progress - 1
        // eslint-disable-next-line require-atomic-updates
        fileprogress.status = '失败'
        delete that.checkpoints[fileprogress.uploadId]
        that.toUpload()
      })
    },

    // 恢复上传。
    async resumeUpload(fileprogress, file, pointInt) {
      const that = this
      if (that.httpupload === null) {
        const res = await getUploadInfo()

        that.httpupload = client(res.data)
      }

      const fileSuffix = fileprogress.name.substring(fileprogress.name.lastIndexOf('.') + 1).toLowerCase()
      return await that.httpupload.multipartUpload(fileprogress.dir + fileprogress.md5 + '.' + fileSuffix, file, {
        parallel: 5,
        partSize: 1024 * 1024,

        progress: function(p, checkpoint) {
          if (checkpoint) {
            fileprogress.uploadId = checkpoint.uploadId
            that.checkpoints[checkpoint.uploadId] = checkpoint
          }
          const progress = parseInt(p * 100)
          if (fileprogress.progress < progress) {
            fileprogress.progress = parseInt(p * 100)
          }
        },
        checkpoint: pointInt

      }).then(result => {
        if (result.res.status === 200) {
          fileprogress.status = '完成'
          fileprogress.uploadDescript = ''
          fileprogress.uploadEndTime = dateFormat(new Date().getTime())
          delete that.checkpoints[fileprogress.uploadId]
          that.toUpload()
        }
      }).catch(err => {
        console.error(err)
        fileprogress.uploadDescript = '上传中断'
        fileprogress.progress = fileprogress.progress - 1
        fileprogress.status = '失败'
        delete that.checkpoints[fileprogress.uploadId]
        that.toUpload()
      })
    },
    // 取消分片上传事件
    async abortMultipartUpload(scope) {
      const uploadId = scope.row.uploadId
      this.$refs.uploadtable.handleRemove(scope.row.file, scope.row.file.raw)
      this.fileList.splice(scope.$index, 1)
      if (uploadId) {
        // const res = await getUploadInfo()

        // const httpupload = client(res.data)
        if (this.httpupload === null) {
          const res = await getUploadInfo()
          this.httpupload = client(res.data)
        }
        const fileSuffix = scope.row.name.substring(scope.row.name.lastIndexOf('.') + 1).toLowerCase()
        await this.httpupload.abortMultipartUpload(scope.row.dir + scope.row.md5 + '.' + fileSuffix, uploadId)
      }
    }

  }
}
</script>

<style lang="scss" scoped>
::v-deep .is-leaf {
  border-bottom: 1px solid #EBEEF5;
  border-top: 1px solid #EBEEF5;
}

::v-deep .el-table__empty-text {
  line-height: 100px;
  width: 50%;
  color: #7B84A1;
  font-size: 12px;
  opacity: 0.5;
}

::v-deep .el-table::before {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0px;
}

.el-table {
  ::v-deep tbody tr:hover>td {
    background-color: transparent;
  }

  ::v-deep th {
    padding: 3px 0;
    min-width: 0;
  }

  ::v-deep td {
    border-bottom: 0px;
    color: #1F233E;
    font-size: 12px;
    padding: 3px 0;
    min-width: 0;
  }
}

.avatar-uploader {
  width: 100%;
  height: 200px;

  &-btn {
    width: 120px;
    height: 30px;
    background: #4C70E8;
    line-height: 30px;
    padding: 0px;
    margin-top: 20px;
    font-size: 14px;
    font-weight: bold;
    border-radius: 5px;
  }

  &-text {
    color: #7B84A1;
    font-size: 24px;
    line-height: 35px;
    // width: 192px;
    opacity: 0.5;
    // height: 23px;
    // margin-top: 53px;
    // font-size: 24px;

    // color: #7B84A1;

    // opacity: 0.5;
  }

  &-stext {

    height: 12px;
    font-size: 12px;
    margin-top: 10px;
    color: #7B84A1;

    opacity: 0.5;
  }

  ::v-deep .el-upload-dragger {
    // border: 0px solid transparent;

    background-color: #F3F4F9;
    border-radius: 6px;
    cursor: pointer;
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    display: flex;
    border: 1px solid transparent;
    background: linear-gradient(#F3F4F9, #F3F4F9) padding-box,
      repeating-linear-gradient(-45deg, #7B84A1 0, #7B84A1 3px, #fff 0, #fff 5px);

    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  ::v-deep .el-upload {
    cursor: pointer;
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
  }

  ::v-deep .el-upload-dragger:hover {
    // border-color: #409EFF;
    border: 1px solid transparent;
    background: linear-gradient(#F3F4F9, #F3F4F9) padding-box,
      repeating-linear-gradient(-45deg, #409EFF 0, #409EFF 3px, #F3F4F9 0, #F3F4F9 5px);
  }
}

.row {
  flex-direction: row;
  display: flex;
  align-items: center;

  &-img {
    opacity: 0.5;
  }

  &-img:hover {
    opacity: 1;
  }
}

.rowright {
  display: flex;
  position: fixed;
  top: 200px;
  width: 100px;
  flex-direction: column;

  &-contain {
    display: flex;
    flex-direction: column;
    // align-items: center;
    justify-content: center;
    padding-left: 10px;
    height: 30px;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    background-color: #b7bccd;
    cursor: pointer;
  }

  &-btn {
    font-size: 12px;
    width: 100px;
    color: #FEFEFE;

  }

  &-next {

    padding: 0px;
    margin: 0px;
    font-size: 18px;
    font-weight: bold;
    color: #FEFEFE;
  }
}

.dashboard {
  margin: auto;
  padding-top: 51px;
  width: 1240px;
  flex-direction: row;
  display: flex;
  box-sizing: border-box;

  &-container {

    padding: 20px;
    border-radius: 5px;
    margin-top: 20px;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
  }

  &-toplayout {
    display: flex;
    // flex-direction: row-reverse;
    margin: 0px 0px 10px 0px;
    align-items: center;
    justify-content: space-between;
    color: #000;
    font-size: 14px;
    line-height: 25px;

    &-right {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-space {
      display: flex;
      align-items: center;
      padding-left: 10px;
      padding-right: 11px;
      justify-content: space-between;
    }

    &-mgright {
      margin-right: 11px;

      font-size: 12px;
      line-height: 24px;
      color: #1F233E;

    }

    &-num {
      // width: 24px;
      height: 24px;
      font-size: 12px;
      margin-right: 11px;
      padding-left: 5px;
      padding-right: 5px;
      // line-height: 24px;
      color: #ffff;
      display: flex;
      justify-content: center;
      background: #7B84A1;
      border-radius: 5px;
    }

    &-btn {
      margin-right: 15px;
      height: 24px;
      width: 176px;
      background: #7B84A1;
      border-radius: 5px;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 24px;
    }

    &-ftsbig {

      font-size: 20px;
      font-weight: bold;
      color: #4C70E8;

    }

    &-ftsnomal {
      /* margin-left: -25px; */
      font-size: 12px;
      color: #1F233E;
      line-height: 24px;

    }

    &-margin {

      font-size: 12px;
      color: #1F233E;
      line-height: 24px;

    }
  }
}
</style>
